// Реестр экранов — общий ключевой контракт навигации.
// Презентация (screen/sheet) — на платформе.
export enum StackMode {
  AUTHORIZED = 'AUTHORIZED',
  LOGOUT = 'LOGOUT',
}

export enum PhoneEntryMode {
  LOGIN = 'login',
  BIND = 'bind',
}

export enum ScreensList {
  // Гостевая зона (стек LOGOUT): вход по номеру телефона и коду
  ENTRY_LOADING = 'ENTRY_LOADING',
  ENTRY_PHONE = 'ENTRY_PHONE',
  ENTRY_OTP = 'ENTRY_OTP',

  // Авторизованная зона (стек AUTHORIZED)
  HOME_START = 'HOME_START',
  TOPUP_AMOUNT = 'TOPUP_AMOUNT',
  PAYMENT_LINK = 'PAYMENT_LINK',
  TX_DETAILS = 'TX_DETAILS',
  CARD_INFO = 'CARD_INFO',
  FORM_SHEET_WALLET_PAY_GUIDE = 'FORM_SHEET_WALLET_PAY_GUIDE',
  CARD_DETAILS = 'CARD_DETAILS',
  CARD_PIN_SETUP = 'CARD_PIN_SETUP',
  FORM_SHEET_SELECT_CARD = 'FORM_SHEET_SELECT_CARD',
  FORM_SHEET_EMAIL_PROMPT = 'FORM_SHEET_EMAIL_PROMPT',
  ENTRY_EMAIL = 'ENTRY_EMAIL',
  FORM_SHEET_PROFILE = 'FORM_SHEET_PROFILE',
  FORM_SHEET_THEME = 'FORM_SHEET_THEME',
  FORM_SHEET_LANGUAGE = 'FORM_SHEET_LANGUAGE',
  FORM_SHEET_FAQ_ANSWER = 'FORM_SHEET_FAQ_ANSWER',
  FORM_SHEET_FAQ = 'FORM_SHEET_FAQ',
  FORM_SHEET_BILLING_ADDRESS = 'FORM_SHEET_BILLING_ADDRESS',
  FORM_SHEET_CARD_READY = 'FORM_SHEET_CARD_READY',
  FORM_SHEET_ISSUE_CARD = 'FORM_SHEET_ISSUE_CARD',
  FORM_SHEET_WITHDRAW_BANK = 'FORM_SHEET_WITHDRAW_BANK',
  WITHDRAW_BANKS = 'WITHDRAW_BANKS',
  WITHDRAW_AMOUNT = 'WITHDRAW_AMOUNT',
  FORM_SHEET_WITHDRAW_CONFIRM = 'FORM_SHEET_WITHDRAW_CONFIRM',
}
